import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import MissionSection from "./components/MissionSection";
import ServicesOverview from "./components/ServicesOverview";
import WhyNairobiSection from "./components/WhyNairobiSection";
import HowWeWorkSection from "./components/HowWeWorkSection";
import LeadershipPreview from "./components/LeadershipPreview";
import InsightsPreview from "./components/InsightsPreview";
import CtaSection from "./components/CtaSection";

export default function HomePage() {
  return (
    <div className="font-['Inter']">
      <Navbar />
      <main>
        <HeroSection />
        <MissionSection />
        <ServicesOverview />
        <WhyNairobiSection />
        <HowWeWorkSection />
        <LeadershipPreview />
        <InsightsPreview />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
